import type React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { usePopup } from '@shared/hooks';
import { MediumModal } from '@shared/ui/modals';
import { MediumHeader } from '@shared/ui/modals';

import { useModalCopyMessage } from './model';
import * as st from './styles.module.scss';

export const ModalMessageCopy: React.FC = () => {
	const { message, toggleCopyModal } = useModalCopyMessage();
	const { popup } = usePopup();

	const onCopy = () => {
		toggleCopyModal();
		popup({ type: 'message', text: 'Скопировано в буфер обмена' });
	};

	return (
		<MediumModal isOpen={!!message?.text} onRequestClose={() => toggleCopyModal()}>
			<MediumHeader title="Оповещение" onClose={() => toggleCopyModal()} />
			<section className={st.body}>
				<div className={st.body__wrap} dangerouslySetInnerHTML={{ __html: message?.html }} />
			</section>
			<section className={st.confirm}>
				<p className={st.confirm__note}>*Скопируйте это сообщение и отправьте вашему клиенту </p>
				<div className={st.confirm__wrap}>
					<CopyToClipboard text={message?.text} onCopy={onCopy}>
						<button className={st.confirm__btn}>Скопировать</button>
					</CopyToClipboard>
				</div>
			</section>
		</MediumModal>
	);
};
